package com.trevorwiebe.timesheet.admin.loadrate.data.dto

import com.trevorwiebe.timesheet.admin.loadrate.domain.model.LoadRate
import com.trevorwiebe.timesheet.admin.loadrate.domain.model.LoadRateCategory
import com.trevorwiebe.timesheet.admin.loadrate.domain.model.LoadRateType
import com.trevorwiebe.timesheet.admin.loadrate.domain.model.LoadRateUnit
import kotlinx.serialization.Serializable

@Serializable
data class LoadRateDto(
    val rateCategory: String = "",
    val rateType: String = "",
    val unit: String? = null,
    val perUnit: Int = 0,
    val flatRate: Int = 0,
    val pickupLocationId: String = "",
    val dropLocationId: String = "",
    val lastUpdated: String = "",
)

// Enums are parsed leniently so one malformed document can't kill the snapshot flow.
internal fun parseLoadRateCategory(raw: String): LoadRateCategory =
    LoadRateCategory.entries.firstOrNull { it.name == raw } ?: LoadRateCategory.BULK

internal fun parseLoadRateType(raw: String): LoadRateType =
    LoadRateType.entries.firstOrNull { it.name == raw } ?: LoadRateType.FLAT_RATE

internal fun parseLoadRateUnit(raw: String?): LoadRateUnit? =
    LoadRateUnit.entries.firstOrNull { it.name == raw }

fun LoadRateDto.toLoadRate(id: String): LoadRate = LoadRate(
    id = id,
    rateCategory = parseLoadRateCategory(rateCategory),
    rateType = parseLoadRateType(rateType),
    unit = parseLoadRateUnit(unit),
    perUnit = perUnit,
    flatRate = flatRate,
    pickupLocationId = pickupLocationId,
    dropLocationId = dropLocationId,
    lastUpdated = lastUpdated,
)

fun LoadRate.toLoadRateDto(): LoadRateDto = LoadRateDto(
    rateCategory = rateCategory.name,
    rateType = rateType.name,
    unit = unit?.name,
    perUnit = perUnit,
    flatRate = flatRate,
    pickupLocationId = pickupLocationId,
    dropLocationId = dropLocationId,
    lastUpdated = lastUpdated,
)
